

    
<template>
  <v-dialog v-model="showEventDetailsModal" max-width="500px">
    <v-card>
      <v-card-title> {{ title }} </v-card-title>
      <v-card-text>
        {{ description }}
      </v-card-text>
      <v-card-actions>
        <v-btn
          v-bind:key="btn"
          color="primary"

          v-on:click="btn_Click(btn)"
          v-for="btn in buttons"
        >
          {{ btn }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


 <style lang="">
</style> 
<script>
export default {
  data: () => ({
    showEventDetailsModal: false,
    buttons: [],
    title: "",
    description: "", 
    callback: function () {},
  }),
  methods: {
    btn_Click(value) { 
      this.showEventDetailsModal = false;
      this.callback(value);
    },
    Show(title, description, buttons,callback) {
      this.dialogResult = "";
      this.title=title;
      this.description=description;
      this.buttons=buttons;
      this.callback=callback;
      this.showEventDetailsModal = true;
    },
  },
};
</script>

